import { lazy } from "react";

import { routers } from "@/configs";

const Terms = lazy(() => import("@/pages/Others/AboutUs/Terms"));
const PrivacyPolicy = lazy(() => import("@/pages/Others/AboutUs/PrivacyPolicy"));
const AboutUs = lazy(() => import("@/pages/Others/AboutUs/AboutUs"));
const ResponsibleGambling = lazy(() => import("@/pages/Others/AboutUs/ResponsibleGambling"));
const AmlKycPolicy = lazy(() => import("@/pages/Others/AboutUs/AmlKycPolicy"));
const BonusTerms = lazy(() => import("@/pages/Others/AboutUs/BonusTerms"));
const CookiePolicy = lazy(() => import("@/pages/Others/AboutUs/CookiePolicy"));

const Mascot = lazy(() => import("@/pages/Others/Mascot"));
const VerifyEmail = lazy(() => import("@/pages/Others/VerifyEmail"));
const ConfirmEmailChange = lazy(() => import("@/pages/Others/ConfirmEmailChange"));
const Unsubscribe = lazy(() => import("@/pages/Others/Unsubscribe"));
const ProvablyFair = lazy(() => import("@/pages/Others/ProvablyFair"));

const Promotion = lazy(() => import("@/pages/Others/Promotion"));
const Referral = lazy(() => import("@/pages/Others/Referral"));
const BetShare = lazy(() => import("@/pages/Others/BetShare"));
const VipClubs = lazy(() => import("@/pages/Others/VipClubs"));
const Tournament = lazy(() => import("@/pages/Others/Tournament"));

const HelpCenter = lazy(() => import("@/pages/Others/HelpCenter"));
const HelpCenterCategory = lazy(() => import("@/pages/Others/HelpCenter/Category"));
const HelpCenterArticle = lazy(() => import("@/pages/Others/HelpCenter/Article"));
const TournamentDetail = lazy(() => import("@/pages/Others/TournamentDetail"));
const WagerRace = lazy(() => import("@/pages/Others/WagerRace"));
const Challenges = lazy(() => import("@/pages/Others/Challenges"));
const SlotBattles = lazy(() => import("@/pages/Others/SlotBattles"));
const SlotBattle = lazy(() => import("@/pages/Others/SlotBattles/Battle"));
const Raffles = lazy(() => import("@/pages/Others/Raffles"));
const Rewards = lazy(() => import("@/pages/Others/Rewards"));
const Shop = lazy(() => import("@/pages/Others/Shop"));

export const OthersRoutes = [
  {
    path: routers.Promotion,
    element: <Promotion />,
  },
  {
    path: routers.Referral,
    element: <Referral />,
  },
  {
    path: routers.BetShare,
    element: <BetShare />,
  },
  {
    path: routers.VipClubs,
    element: <VipClubs />,
  },
  {
    path: routers.Tournament,
    element: <Tournament />,
  },
  {
    path: routers.TournamentDetail,
    element: <TournamentDetail />,
  },
  {
    path: routers.WagerRace,
    element: <WagerRace />,
  },
  {
    path: routers.Challenges,
    element: <Challenges />,
  },
  {
    path: routers.SlotBattles,
    element: <SlotBattles />,
  },
  {
    path: routers.SlotBattle,
    element: <SlotBattle />,
  },
  {
    path: routers.Raffles,
    element: <Raffles />,
  },
  {
    path: routers.Rewards,
    element: <Rewards />,
  },
  {
    path: routers.Shop,
    element: <Shop />,
  },
  {
    path: routers.PrivacyPolicy,
    element: <PrivacyPolicy />,
  },
  {
    path: routers.TermsService,
    element: <Terms />,
  },
  {
    path: routers.ResponsibleGambling,
    element: <ResponsibleGambling />,
  },
  {
    path: routers.AmlKycPolicy,
    element: <AmlKycPolicy />,
  },
  {
    path: routers.BonusTerms,
    element: <BonusTerms />,
  },
  {
    path: routers.CookiePolicy,
    element: <CookiePolicy />,
  },
  {
    path: routers.AboutUs,
    element: <AboutUs />,
  },
  {
    path: routers.Mascot,
    element: <Mascot />,
  },
  {
    path: routers.VerifyEmail,
    element: <VerifyEmail />,
  },
  {
    path: routers.ConfirmEmailChange,
    element: <ConfirmEmailChange />,
  },
  {
    path: routers.Unsubscribe,
    element: <Unsubscribe />,
  },
  {
    path: routers.ProvablyFair,
    element: <ProvablyFair />,
  },
  {
    path: routers.HelpCenter,
    element: <HelpCenter />,
  },
  {
    path: routers.HelpCenterArticle,
    element: <HelpCenterArticle />,
  },
  {
    path: routers.HelpCenterCategory,
    element: <HelpCenterCategory />,
  },
];
